export default (instructor) => (
  instructor.id
    ? instructor.customization && instructor.customization.siteTemplate || ''
    : ''
);
